import React from 'react';
import { Plus } from 'lucide-react';

interface EmptySlotProps {
  onClick: () => void;
  isActive: boolean;
  isExport?: boolean;
}

export const EmptySlot: React.FC<EmptySlotProps> = ({
  onClick,
  isActive,
  isExport = false
}) => (
  <div
    onClick={!isExport ? onClick : undefined}
    className={`w-full aspect-[3/4] rounded-lg border-2 border-dashed transition-all duration-200 flex flex-col items-center justify-center ${
      isActive ? 'border-primary bg-primary/5' : 'border-border bg-muted/30'
    } ${isExport ? 'border-border opacity-20' : 'cursor-pointer hover:bg-secondary'}`}
  >
    {!isExport && <Plus size={14} className={isActive ? 'text-primary' : 'text-muted-foreground'} />}
  </div>
);
